module.exports = __webpack_public_path__ + "img/12.0b948549.jpg";